const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullGlass(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.442,
    height: 90.915,
    viewBox: "0 0 16.257 24.055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#79ccce",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0 7.812-60.884c0-1.608 6.817-2.912 15.229-2.912 8.41 0 15.23 1.304 15.23 2.912L46.081 0z",
    transform: "matrix(.35278 0 0 -.35278 0 1.549)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61bcbc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c0 2.424-10.316 4.39-23.04 4.39-12.724 0-23.041-1.966-23.041-4.39 0-2.423 10.317-4.389 23.041-4.389S0-2.423 0 0",
    transform: "matrix(.35278 0 0 -.35278 16.256 1.549)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#008ca2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0 5.629-43.87c1.325-.636 5.928-1.601 13.214-1.601 7.287 0 11.887.965 13.216 1.601L37.687 0z",
    transform: "matrix(.35278 0 0 -.35278 1.481 7.273)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00a9b9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c0 1.982-8.438 3.589-18.844 3.589-10.407 0-18.843-1.607-18.843-3.589s8.436-3.589 18.843-3.589C-8.438-3.589 0-1.982 0 0",
    transform: "matrix(.35278 0 0 -.35278 14.776 7.273)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullGlass);
export default __webpack_public_path__ + "static/media/full_glass.e313b9d2504ae906d8651ac5097299ed.svg";
export { ForwardRef as ReactComponent };